<template>
  <div class="mb-6" v-if="dataset">
    <v-container class="pb-0" v-if="showMobileView">
      <div class="d-flex">
        <slot name="search" />
        <slot name="filter" />
      </div>
    </v-container>
    <v-layout
      v-if="!showMobileView"
      class="d-flex justify-space-between align-center"
    >
      <slot name="filter" />
      <slot name="search" />
    </v-layout>
    <slot name="button" />
    <div
      class="d-flex justify-center align-center"
      style="min-height:800px;"
      v-if="loading"
    >
      <v-progress-circular indeterminate size="100" />
    </div>
    <div>
      <data-card
        v-if="!showMobileView && headers && !loading"
        :header="true"
        :scrollWidth="scrollWidth"
        :click="true"
      >
        <v-row
          class="d-flex justify-space-between pl-3 pr-3"
          id="table-headers"
        >
          <div
            v-for="(header, index) in headers"
            :key="index"
            :style="headerStyle"
            :id="
              'table-title-' +
                header
                  .toLowerCase()
                  .split(' ')
                  .join('-')
            "
          >
            {{ header }}
          </div>
        </v-row>
      </data-card>
      <div v-if="dataset.data && !loading">
        <v-virtual-scroll
          :items="dataset.data"
          :height="scrollHeight"
          item-height="82"
          ref="vscroll"
          id="table-scroll"
        >
          <template v-slot:default="{ item }">
            <data-card
              :key="item.id"
              :data="item"
              :type="type"
              :class="cardClass"
              :tab="tab"
              id="data-row"
            >
              <slot name="content" :data="item">{{ item.content }}</slot>
            </data-card>
          </template>
        </v-virtual-scroll>
        <div v-if="lastEvalKey" class="d-flex justify-end">
          <v-btn
            class="white--text mx-8 mt-2"
            style="width: 100px"
            color="secondary"
            @click="getMoreData"
            >Get More</v-btn
          >
        </div>
      </div>
      <div v-if="dataset && !loading">
        <v-virtual-scroll
          :items="dataset"
          :height="scrollHeight"
          ref="vscroll"
          :item-height="itemHeight"
          id="table-scroll"
        >
          <template v-slot:default="{ item }">
            <data-card
              :key="item.id"
              :data="item"
              :type="type"
              :class="cardClass"
              :tab="tab"
              id="data-row"
            >
              <slot name="content" :data="item">{{ item.content }}</slot>
            </data-card>
          </template>
        </v-virtual-scroll>
        <div v-if="lastEvalKey" class="d-flex justify-end">
          <v-btn
            class="white--text mx-8 mt-2"
            style="width: 100px"
            color="secondary"
            @click="getMoreData"
            >Get More</v-btn
          >
        </div>
      </div>
    </div>
    <div v-if="dataset && dataset.length === 0 && !loading">
      <v-card-text class="text-center">
        No matching data found!
      </v-card-text>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex';
import DataCard from '@/components/app/DataCard.vue';
import FilterParams from '@/mixins/FilterParams';
import { MobileView } from '@/mixins';
import router from '../../router';

export default {
  props: ['dataset', 'type', 'queryParams', 'headers', 'tab', 'loading'],
  mixins: [MobileView, FilterParams],
  components: {
    DataCard,
  },
  data() {
    return {
      scrollWidth: 0,
    };
  },
  methods: {
    ...mapMutations({
      _setFilter: 'filters/setFilters',
      _setDataPresent: 'filters/setDataPresent',
    }),
    ...mapActions({
      _getKeyData: 'digitalKeys/acquireData',
      _getGroupData: 'groups/acquireGroups',
    }),
    getMoreData() {
      const paginate = true;
      switch (this.$router.history.current.name) {
        case 'Groups':
          this._getGroupData(paginate);
          break;
        case 'Screens':
          this._getScreenData(paginate);
          break;
        case 'Keys':
          this._getKeyData(paginate);
          break;
        case 'Reports':
          this._getReportInstances(paginate);
          break;
        case 'Reconciliation':
          this._getRentalData(paginate);
          this._getOneWayData(paginate);
          break;
        default:
          break;
      }
    },
  },
  computed: {
    cardClass() {
      if (!this.showMobileView && this.headers) {
        return 'mb-0 mt-1 d-flex align-center';
      }
      return '';
    },
    lastEvalKey() {
      const route = this.$router.history.current.name.toLowerCase();
      return this.$store.getters[`${route}/getLastEvalKey`];
    },
    pageNumber() {
      return this.filterParams.page ? this.filterParams.page.toString() : 1;
    },
    headerStyle() {
      if (router.history.current.name === 'Screens') {
        if (this._client.client_name === 'shark') {
          return 'width:12.5%; font-size:12px; color: #777777;';
        }
        return 'width:15%; font-size:12px; color: #777777;';
      } if (
        router.history.current.name === 'Reports'
        || router.history.current.name === 'Users'
      ) {
        return 'width:10%; font-size:12px; color: #777777;';
      }
      return 'width:12%; font-size:12px; color: #777777;';
    },
    scrollHeight() {
      if (this.dataset.length === 0) {
        return '0px';
      }
      return '600px';
    },
    paginationStyle() {
      if (!this.showMobileView) {
        return 'mx-4 d-flex pt-4';
      }
      return 'mx-4';
    },
    itemHeight() {
      if (!this.showMobileView) {
        return '82';
      }
      return '150';
    },
  },
  updated() {
    if (this.$refs.vscroll && this.$refs.vscroll.$el) {
      this.scrollWidth = this.$refs.vscroll.$el.offsetWidth - this.$refs.vscroll.$el.clientWidth;
    }
  },
  watch: {
    dataset() {
      this._setDataPresent(!!this.dataset.length);
    },
  },
};
</script>
